<template>
  <div class="home-page container-md">
    <h2>Dropdown下拉菜单</h2>
    <p>向下弹出的列表。</p>

    <h4>何时使用</h4>
    <p>当页面上的操作命令过多时，用此组件可以收纳操作元素。点击或移入触点，会出现一个下拉菜单。可在列表中进行选择，并执行相应的命令。</p>

    <h4>演示</h4>
    <dropdown title="你好 点击我试试">
      <dropdown-item closeAfterClick><a href="#" class="dropdown-item">新建文章</a></dropdown-item>
      <dropdown-item closeAfterClick><a href="#" class="dropdown-item">我的专栏</a></dropdown-item>
      <dropdown-item closeAfterClick><a href="#" class="dropdown-item">编辑资料</a></dropdown-item>
      <dropdown-item closeAfterClick><a href="#" class="dropdown-item">退出登陆</a></dropdown-item>
    </dropdown>
    <h4 class="mt-4">代码</h4>
    <pre class="language-html">
      <code v-html="highlightedCode"></code>
    </pre>
    <h4>Dropdown 属性和事件</h4>
    <props-table :props="props"></props-table>
    <h4>DropdownItem 属性和事件</h4>
    <props-table :props="props2"></props-table>
  </div>
</template>

<script>
import Prism from 'prismjs'
import Dropdown from '../components/Dropdown.vue'
import DropdownItem from '../components/DropdownItem.vue'
import PropsTable from '../components/PropsTable.vue'
export default {
  data () {
    return {
      props: [
        { name: 'title', type: 'string', desc: 'Dropdown 中的标题文本' },
        { name: 'item-clicked', type: '事件', desc: '回调参数 (event) => void' }
      ],
      props2: [
        { name: 'disabled', type: 'boolean', desc: '禁用 Dropdown Item', default: 'false' },
        { name: 'closeAfterClick', type: 'boolean', desc: '点击 Item 以后是否关闭菜单', default: 'false' }
      ],
      code: `
      <dropdown title="你好 点击我试试">
        <dropdown-item closeAfterClick>
          <a href="#" class="dropdown-item">新建文章</a>
        </dropdown-item>
        <dropdown-item>
          <a href="#" class="dropdown-item">我的专栏</a>
        </dropdown-item>
        <dropdown-item>
          <a href="#" class="dropdown-item">编辑资料</a>
        </dropdown-item>
        <dropdown-item closeAfterClick>
          <a href="#" class="dropdown-item">退出登陆</a>
        </dropdown-item>
      </dropdown>`
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(this.code, Prism.languages.html)
    }
  },
  components: {
    Dropdown,
    DropdownItem,
    PropsTable
  }
}
</script>
